<template>
    <div class="regbg">
        <ul class="regbg-ul">
            <li class="regbg-round" :class="{'active':index+1 == step}" v-for="(item,index) in stepLists">
                <div  :class="['round-jt' + (index+1)]">
                    <span class="num">{{index + 1}}</span>
                    <span class="txt">{{item}}</span>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
    export default{
        props:{
            step:{
                type:Number,
                default:1
            }
        },
        data(){
            return {
                stepLists:['手机验证','企业信息','资料上传','注册完成']
            }
        }
    }
</script>




// WEBPACK FOOTER //
// Regstepimg.vue?155567a3